import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type CardElevation = 'flat' | 'raised';

/**
 * Content sections are projected via attribute selectors:
 *   <ds-card>
 *     <h3 ds-card-title>…</h3>
 *     …body content…
 *     <div ds-card-footer>…</div>
 *   </ds-card>
 */
@Component({
  selector: 'ds-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class]': 'classes()' },
  template: `
    <ng-content select="[ds-card-title]" />
    <div class="card__body">
      <ng-content />
    </div>
    <ng-content select="[ds-card-footer]" />
  `,
  styles: `
    :host {
      display: block;
      background: var(--color-surface);
      border-radius: var(--radius-md);
      padding: var(--space-5);
    }

    :host(.card--flat) {
      border: 1px solid var(--color-border);
    }

    :host(.card--raised) {
      border: 1px solid var(--color-border-subtle);
    }

    .card__body {
      color: var(--color-text);
    }
  `,
})
export class CardComponent {
  elevation = input<CardElevation>('flat');

  protected classes = computed(() => `card--${this.elevation()}`);
}
